import { Routes } from '@angular/router';

// import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/auth/login/login.component';
import { PrivacyPolicyComponent } from './components/auth/privacy-policy/privacy-policy.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { OtpComponent } from './components/auth/otp/otp.component';

import { RegistrationComponent } from './components/auth/registration/registration.component';

import { OsintImageSearchComponent } from './components/osint-search/osint-image-search/osint-image-search.component';
import { FaceCompareComponent } from './components/osint-search/face-compare/face-compare.component';
import { FaceCompareUploaderComponent } from './components/osint-search/face-compare/face-compare-uploader/face-compare-uploader.component';
import { FaceCompareFaceDetectorComponent } from './components/osint-search/face-compare/face-compare-face-detector/face-compare-face-detector.component';
import { VideoScannerComponent } from './components/osint-search/video-scanner/video-scanner.component';
import { VideoUploaderComponent } from './components/osint-search/video-scanner/video-uploader/video-uploader.component';
import { ScannedResultsComponent } from './components/osint-search/video-scanner/scanned-results/scanned-results.component';
import { OsintImageSearchResultComponent } from './components/osint-search/osint-image-search-result/osint-image-search-result.component';
import { OsintNumberSearchComponent } from './components/osint-search/osint-number-search/osint-number-search.component';
import { OsintNumberSearchResultComponent } from './components/osint-search/osint-number-search-result/osint-number-search-result.component';
import { OsintEmailSearchComponent } from './components/osint-search/osint-email-search/osint-email-search.component';
import { OsintEmailSearchResultComponent } from './components/osint-search/osint-email-search-result/osint-email-search-result.component';

import { OsintUsernameSearchComponent } from './components/osint-search/osint-username-search/osint-username-search.component';
import { OsintUsernameSearchResultComponent } from './components/osint-search/osint-username-search-result/osint-username-search-result.component';
import { OsintSearchPrintableComponent } from './components/osint-search/osint-search-printable/osint-search-printable.component';

import { OsintNameSearchComponent } from './components/osint-search/osint-name-search/osint-name-search.component';
import { OsintNameSearchResultComponent } from './components/osint-search/osint-name-search-result/osint-name-search-result.component';

import { OsintWalletSearchComponent } from './components/osint-search/osint-wallet-search/osint-wallet-search.component';
import { OsintWalletSearchResultComponent } from './components/osint-search/osint-wallet-search-result/osint-wallet-search-result.component';
import { OsintGstSearchComponent } from './components/osint-search/osint-gst-search/osint-gst-search.component';
import { OsintGstSearchResultComponent } from './components/osint-search/osint-gst-search-result/osint-gst-search-result.component';
import { OsintDinSearchComponent } from './components/osint-search/osint-din-search/osint-din-search.component';
import { OsintDinSearchResultComponent } from './components/osint-search/osint-din-search-result/osint-din-search-result.component';
import { OsintMobilePanSearchComponent } from './components/osint-search/osint-mobile-pan-search/osint-mobile-pan-search.component';
import { OsintMobilePanSearchResultComponent } from './components/osint-search/osint-mobile-pan-search-result/osint-mobile-pan-search-result.component';
import { OsintPhonepeFastagSearchComponent } from './components/osint-search/osint-phonepe-fastag-search/osint-phonepe-fastag-search.component';
import { OsintPhonepeFastagSearchResultComponent } from './components/osint-search/osint-phonepe-fastag-search-result/osint-phonepe-fastag-search-result.component';
import { OsintPhonepeUpiSearchComponent } from './components/osint-search/osint-phonepe-upi-search/osint-phonepe-upi-search.component';
import { OsintPhonepeUpiSearchResultComponent } from './components/osint-search/osint-phonepe-upi-search-result/osint-phonepe-upi-search-result.component';
import { PanSearchComponent } from './components/pan/pan-search/pan-search.component';
import { PanSearchResultComponent } from './components/pan/pan-search-result/pan-search-result.component';
import { WebCaptureSearchComponent } from './components/web-capture/web-capture-search/web-capture-search.component';
import { WebCaptureResultComponent } from './components/web-capture/web-capture-result/web-capture-result.component';
import { AdvancedSearchComponent } from './components/advanced/advanced-search/advanced-search.component';
import { AdvancedSearchResultComponent } from './components/advanced/advanced-search-result/advanced-search-result.component';

import { LeakNumberSearchComponent } from './components/leak-search/leak-number-search/leak-number-search.component';
import { LeakNumberSearchResultComponent } from './components/leak-search/leak-number-search-result/leak-number-search-result.component';
import { LeakEmailSearchComponent } from './components/leak-search/leak-email-search/leak-email-search.component';
import { LeakEmailSearchResultComponent } from './components/leak-search/leak-email-search-result/leak-email-search-result.component';
import { LeakUsernameSearchComponent } from './components/leak-search/leak-username-search/leak-username-search.component';
import { LeakUsernameSearchResultComponent } from './components/leak-search/leak-username-search-result/leak-username-search-result.component';
import { LeakPasswordSearchComponent } from './components/leak-search/leak-password-search/leak-password-search.component';
import { LeakPasswordSearchResultComponent } from './components/leak-search/leak-password-search-result/leak-password-search-result.component';

import { AdvancedLeakEmailSearchComponent } from './components/advanced-leak-search/advanced-leak-email-search/advanced-leak-email-search.component';
import { AdvancedLeakEmailSearchResultComponent } from './components/advanced-leak-search/advanced-leak-email-search-result/advanced-leak-email-search-result.component';
import { AdvancedLeakNumberSearchComponent } from './components/advanced-leak-search/advanced-leak-number-search/advanced-leak-number-search.component';
import { AdvancedLeakNumberSearchResultComponent } from './components/advanced-leak-search/advanced-leak-number-search-result/advanced-leak-number-search-result.component';

import { SearchHistoryComponent } from './components/search-history/search-history.component';
import { ContactDirectoryComponent } from './components/contact-directory/contact-directory.component';
import { MyContributionsComponent } from './components/contact-directory/my-contributions/my-contributions.component';
import { LeaderboardComponent } from './components/contact-directory/leaderboard/leaderboard.component';
import { VirtualNumberComponent } from './components/virtual-number/virtual-number.component';
import { VehicleSearchComponent } from './components/vehicle/vehicle-search/vehicle-search.component';
import { VehicleSearchResultComponent } from './components/vehicle/vehicle-search-result/vehicle-search-result.component';

import { UserAccountComponent } from './components/home/user-account/user-account.component';
import { NotificationsPageComponent } from './components/home/notifications-page/notifications-page.component';
import { PlanPricingComponent } from './components/home/plan-pricing/plan-pricing.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { PageNotFoundComponent } from './components/common/page-not-found/page-not-found.component';
import { ServiceNotAvailableComponent } from './components/common/service-not-available/service-not-available.component';

import { AuthGuard } from './guards/auth/auth.guard';
import { PermissionGuard } from './guards/permission/permission.guard';
import { TwoFaComponent } from './components/auth/login/two-fa/two-fa.component';
import { BasicSearchComponent } from './components/basic/basic-search/basic-search.component';
import { BasicSearchResultComponent } from './components/basic/basic-search-result/basic-search-result.component';
import { GenerateTrackingLinkComponent } from './components/advanced-link-tracking/generate-tracking-link/generate-tracking-link.component';
import { TrackingLinkResultComponent } from './components/advanced-link-tracking/tracking-link-result/tracking-link-result.component';
import { LinkAnalysisSearchComponent } from './components/link-analysis/link-analysis-search/link-analysis-search.component';
import { LinkAnalysisResultComponent } from './components/link-analysis/link-analysis-result/link-analysis-result.component';

export const routes: Routes = [
  // PUBLIC ROUTES
  { path: '', component: LoginComponent, pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegistrationComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'otp', component: OtpComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'login/verify-2fa', component: TwoFaComponent },

  // PROTECTED ROUTES
  {
    path: '',
    canActivate: [AuthGuard, PermissionGuard],
    children: [
      { path: 'osint-image-search', component: OsintImageSearchComponent },
      {
        path: 'osint-image-search/face-compare',
        component: FaceCompareComponent,
        children: [
          { path: '', redirectTo: 'upload', pathMatch: 'full' },
          { path: 'upload', component: FaceCompareUploaderComponent },
          { path: 'detector', component: FaceCompareFaceDetectorComponent },
          { path: 'view-uploads', redirectTo: 'upload', pathMatch: 'full' },
        ],
      },
      {
        path: 'osint-image-search/video-scanner',
        component: VideoScannerComponent,
        children: [
          { path: '', redirectTo: 'upload', pathMatch: 'full' },
          { path: 'upload', component: VideoUploaderComponent },
          { path: 'results', component: ScannedResultsComponent },
        ],
      },
      {
        path: 'osint-image-search-result',
        component: OsintImageSearchResultComponent,
      },
      { path: 'home', component: OsintNumberSearchComponent },
      { path: 'osint-number-search', component: OsintNumberSearchComponent },
      { path: 'link-analysis', component: LinkAnalysisSearchComponent },
      {
        path: 'link-analysis/result/:id',
        component: LinkAnalysisResultComponent,
      },
      {
        path: 'osint-number-search/search-result/:id',
        component: OsintNumberSearchResultComponent,
      },
      { path: 'osint-email-search', component: OsintEmailSearchComponent },
      {
        path: 'osint-email-search/search-result/:id',
        component: OsintEmailSearchResultComponent,
      },
      {
        path: 'osint-username-search',
        component: OsintUsernameSearchComponent,
      },
      {
        path: 'osint-username-search/search-result/:id',
        component: OsintUsernameSearchResultComponent,
      },
      {
        path: 'osint-username-search/printable/:id',
        component: OsintSearchPrintableComponent,
        data: { searchType: 'username' },
      },
      {
        path: 'osint-number-search/printable/:id',
        component: OsintSearchPrintableComponent,
        data: { searchType: 'phone' },
      },
      {
        path: 'osint-name-search/printable/:id',
        component: OsintSearchPrintableComponent,
        data: { searchType: 'name' },
      },
      {
        path: 'osint-email-search/printable/:id',
        component: OsintSearchPrintableComponent,
        data: { searchType: 'email' },
      },
      { path: 'osint-name-search', component: OsintNameSearchComponent },
      {
        path: 'osint-name-search/search-result/:id',
        component: OsintNameSearchResultComponent,
      },
      { path: 'osint-wallet-search', component: OsintWalletSearchComponent },
      {
        path: 'osint-wallet-search/search-result/:id',
        component: OsintWalletSearchResultComponent,
      },
      { path: 'gst-search', component: OsintGstSearchComponent },
      {
        path: 'gst-search-result/:id',
        component: OsintGstSearchResultComponent,
      },
      {
        path: 'gst-search/printable/:id',
        component: OsintSearchPrintableComponent,
        data: { searchType: 'gst' },
      },
      { path: 'osint-gst-search', redirectTo: 'gst-search', pathMatch: 'full' },
      {
        path: 'osint-gst-search/search-result/:id',
        redirectTo: 'gst-search-result/:id',
      },
      {
        path: 'osint-gst-search/printable/:id',
        redirectTo: 'gst-search/printable/:id',
      },
      { path: 'din-search', component: OsintDinSearchComponent },
      {
        path: 'din-search-result/:id',
        component: OsintDinSearchResultComponent,
      },
      {
        path: 'din-search/printable/:id',
        component: OsintSearchPrintableComponent,
        data: { searchType: 'din' },
      },
      { path: 'osint-din-search', redirectTo: 'din-search', pathMatch: 'full' },
      {
        path: 'osint-din-search/search-result/:id',
        redirectTo: 'din-search-result/:id',
      },
      {
        path: 'osint-din-search/printable/:id',
        redirectTo: 'din-search/printable/:id',
      },
      { path: 'mobile-pan-search', component: OsintMobilePanSearchComponent },
      {
        path: 'mobile-pan-search-result/:id',
        component: OsintMobilePanSearchResultComponent,
      },
      {
        path: 'phonepe-fastag-search',
        component: OsintPhonepeFastagSearchComponent,
      },
      {
        path: 'phonepe-fastag-search-result/:id',
        component: OsintPhonepeFastagSearchResultComponent,
      },
      {
        path: 'phonepe-upi-search',
        component: OsintPhonepeUpiSearchComponent,
      },
      {
        path: 'phonepe-upi-search-result/:id',
        component: OsintPhonepeUpiSearchResultComponent,
      },

      {
        path: 'leak-number-search',
        component: LeakNumberSearchComponent,
      },
      {
        path: 'leak-number-search/search-result/:id',
        component: LeakNumberSearchResultComponent,
      },
      { path: 'leak-email-search', component: LeakEmailSearchComponent },
      {
        path: 'leak-email-search/search-result/:id',
        component: LeakEmailSearchResultComponent,
      },
      { path: 'leak-username-search', component: LeakUsernameSearchComponent },
      {
        path: 'leak-username-search/search-result/:id',
        component: LeakUsernameSearchResultComponent,
      },
      { path: 'leak-password-search', component: LeakPasswordSearchComponent },
      {
        path: 'leak-password-search/search-result/:id',
        component: LeakPasswordSearchResultComponent,
      },
      {
        path: 'advanced-leak-email-search',
        component: AdvancedLeakEmailSearchComponent,
      },
      {
        path: 'advanced-leak-email-search/search-result/:id',
        component: AdvancedLeakEmailSearchResultComponent,
      },

      {
        path: 'advanced-leak-number-search',
        component: AdvancedLeakNumberSearchComponent,
      },
      {
        path: 'advanced-leak-number-search/search-result/:id',
        component: AdvancedLeakNumberSearchResultComponent,
      },
      {
        path: 'basic-search',
        component: BasicSearchComponent,
      },
      {
        path: 'basic-search-result/:id',
        component: BasicSearchResultComponent,
      },
      { path: 'vehicle-search', component: VehicleSearchComponent },
      {
        path: 'vehicle-search-result/:id',
        component: VehicleSearchResultComponent,
      },
      { path: 'pan-search', component: PanSearchComponent },
      {
        path: 'pan-search-result/:id',
        component: PanSearchResultComponent,
      },
      { path: 'web-capture', component: WebCaptureSearchComponent },
      {
        path: 'web-capture-result/:id',
        component: WebCaptureResultComponent,
      },
      { path: 'advanced-search', component: AdvancedSearchComponent },
      {
        path: 'advanced-search-result/:id',
        component: AdvancedSearchResultComponent,
      },
      {
        path: 'generate-tracking-link',
        component: GenerateTrackingLinkComponent,
      },
      {
        path: 'generate-tracking-link/result/:id',
        component: TrackingLinkResultComponent,
      },

      { path: 'search-history', component: SearchHistoryComponent },
      {
        path: 'help',
        loadComponent: () =>
          import('./components/user-help/user-help.component').then(
            (m) => m.UserHelpComponent,
          ),
      },
      { path: 'plan-pricing', component: PlanPricingComponent },
      { path: 'contact-directory', component: ContactDirectoryComponent },
      { path: 'virtual-number', component: VirtualNumberComponent },
      { path: 'my-contributions', component: MyContributionsComponent },
      { path: 'leaderboard', component: LeaderboardComponent },
      { path: 'user-account', component: UserAccountComponent },
      { path: 'notifications', component: NotificationsPageComponent },
      { path: 'feedback', component: FeedbackComponent }
    ],
  },

  // WILDCARD ROUTES
  { path: '**', component: PageNotFoundComponent },
];
